import { CART_LOAD, CART_LOAD_SUCCESS, CART_LOAD_FAILURE, CART_OPTIMISTIC_UPDATE, CART_CHANGES_ACCEPTED, TOGGLE_IGNORE_AVAILABILITY, } from "./action-creators";
import { UPDATE_APP_SHELL_DATA, } from "../AppShell/action-creators";
import currentPageIsCheckout from "../Checkout/Pages/Checkout/current-page-is-checkout";
export default function (state = null, action, currentPage, appShellData) {
    if (state === null) {
        state = Object.assign({}, appShellData.cart, {
            isLoading: false,
            pendingChanges: [],
        });
    }
    switch (action.type) {
        case TOGGLE_IGNORE_AVAILABILITY: {
            return Object.assign({}, state, {
                ignoreAvailability: action.ignoreAvailability,
            });
        }
        case CART_LOAD: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CART_LOAD_SUCCESS: {
            const newState = Object.assign({}, action.cart, {
                isLoading: state.pendingChanges.length > 0,
                pendingChanges: state.pendingChanges,
            });
            return applyPendingChanges(newState, newState.pendingChanges);
        }
        case UPDATE_APP_SHELL_DATA: {
            return Object.assign({}, action.appShellData.cart, {
                isLoading: false,
                pendingChanges: [],
            });
        }
        case CART_LOAD_FAILURE: {
            const firstPendingChange = state.pendingChanges[0];
            if (!firstPendingChange) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                pendingChanges: [],
                items: state.items.map((item) => {
                    let updatedItem;
                    Object.keys(firstPendingChange.items).forEach((code) => {
                        if (code === item.lineItem.code) {
                            updatedItem = {
                                product: item.product,
                                lineItem: Object.assign(Object.assign({}, item.lineItem), { quantity: firstPendingChange.items[code].previousQuantity, unitShortName: firstPendingChange.items[code].previousUnitShortName, selectedVariant: Object.assign(Object.assign({}, item.lineItem.selectedVariant), { unitShortName: firstPendingChange.items[code].previousUnitShortName }) }),
                            };
                        }
                    });
                    return updatedItem || item;
                }),
            });
        }
        case CART_OPTIMISTIC_UPDATE: {
            const diff = [action.diff];
            let newState = Object.assign({}, state);
            newState.pendingChanges = (newState.pendingChanges || []).concat(diff);
            return applyPendingChanges(newState, diff);
        }
        case CART_CHANGES_ACCEPTED: {
            const acceptedChangeIds = action.changes.map((c) => c.id);
            let newState = Object.assign({}, state);
            newState.pendingChanges = newState.pendingChanges.filter((p) => acceptedChangeIds.indexOf(p.id) === -1);
            newState.items = newState.items.filter((i) => i.lineItem.quantity > 0);
            return newState;
        }
        default:
            return state;
    }
}
export function applyPendingChanges(state, pendingChanges) {
    if (!pendingChanges || !pendingChanges.length) {
        return state;
    }
    const itemLengthBeforeChange = state.items.length;
    pendingChanges.forEach((pendingChange) => {
        Object.keys(pendingChange.items).forEach((code) => {
            const items = state.items.map((cartItem) => {
                if (cartItem.lineItem.code === code) {
                    const pendingLineItemChange = pendingChange.items[code];
                    const newChanges = {
                        quantity: pendingLineItemChange.newQuantity,
                        ignoreAvailability: pendingLineItemChange.newIgnoreAvailability,
                        isProductSample: pendingLineItemChange.newIsProductSample,
                        discountType: pendingLineItemChange.newDiscountType,
                        discountValue: pendingLineItemChange.newDiscountValue,
                    };
                    const applyDefinedChanges = (item) => {
                        return Object.keys(item)
                            .filter((key) => item[key] !== undefined)
                            .reduce((prev, curr) => {
                            prev[curr] = item[curr];
                            return prev;
                        }, {});
                    };
                    return Object.assign(Object.assign({}, cartItem), { lineItem: Object.assign(Object.assign(Object.assign(Object.assign({}, cartItem.lineItem), { unitShortName: pendingLineItemChange.newUnitShortName }), applyDefinedChanges(newChanges)), { selectedVariant: Object.assign(Object.assign({}, cartItem.lineItem.selectedVariant), applyDefinedChanges({
                                unitShortName: pendingLineItemChange.newUnitShortName,
                            })) }) });
                }
                else {
                    return cartItem;
                }
            });
            state.items = items;
        });
    });
    // If we remove an item we need a new cart object to rerender but if we only change an item it's enough to just have new object for that item.
    return state.items.length !== itemLengthBeforeChange ? Object.assign({}, state) : state;
}
export function getCartLineItemsForVariants(state, variants) {
    if (!variants || variants.length < 1) {
        return [];
    }
    return variants
        .map((v) => getCartLineItemForVariant(state, v))
        .filter(Boolean);
}
export function getCartLineItemForVariant(state, variant) {
    if (!variant) {
        return null;
    }
    const cart = currentPageIsCheckout(state.currentPage)
        ? state.checkout.cart
        : state.cart;
    const cartLineItem = cart.items.find((i) => i.lineItem.code === variant.code);
    return cartLineItem ? cartLineItem.lineItem : null;
}
export function getCartLineItemCountForVariant(state, variant) {
    const cartLineItem = getCartLineItemForVariant(state, variant);
    return cartLineItem ? cartLineItem.quantity : 0;
}
export function quantityIncludingSubdeliveries(lineItem) {
    return (lineItem.quantity +
        lineItem.subDeliveries.reduce((sum, subDelivery) => sum + subDelivery.quantity, 0));
}
